import styled, {css} from "styled-components"

import {CommonProps, commonCSS} from "../common"
import {mainStyles, largeStyles, regularStyles, smallStyles} from "./styles"

export interface AvatarProps extends CommonProps {
  small?: boolean
  regular?: boolean
  large?: boolean
  id?: string
}

export default styled.span<AvatarProps>`
  ${mainStyles}

  ${({small}) => small && smallStyles}
  ${({regular}) => regular && regularStyles}
  ${({large}) => large && largeStyles}

  /* calculate size responsively if not specified */

  ${({small, regular, large, theme}) =>
    !small &&
    !regular &&
    !large &&
    css`
      ${smallStyles}

      ${theme.mediaQueries.minWidthMedia.tablet`
      ${regularStyles}
    `}
    `}

  ${commonCSS}
`
